import { IAddUserAcademies, IUser } from '@sdk/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { sdk } from '@/services';

const UserService = sdk.getService('UserService');

export const useMutateUsers = () => {
  const queryClient = useQueryClient();
  const onSuccess = () => queryClient.invalidateQueries({ queryKey: ['users'] });

  const { mutate: createUser, isPending: isCreating } = useMutation({
    mutationFn: (create: IUser) => UserService.createUser(create),
    onSuccess
  });

  const { mutate: updateUser, isPending: isUpdating } = useMutation({
    mutationFn: (update: IUser) => UserService.updateUser(update),
    onSuccess
  });

  const { mutate: addUserAcademies, isPending: isAddingUserAcademies } = useMutation({
    mutationFn: (addAcademies: IAddUserAcademies) => UserService.addUserAcademies(addAcademies),
    onSuccess
  });

  return {
    createUser,
    updateUser,
    addUserAcademies,
    isWorking: isCreating || isUpdating || isAddingUserAcademies
  };
};
